export const FONT_SIZE_BUTTON_DATA_HOOK = 'customFontSizeButton';
